import * as React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
const FormContent = styled.div`
  display: flex;
  flex-direction row;

  > :not(:last-child) {
    margin-right: 5px;
  }

  > * {
    display: inline-block;
  }
`;
const SearchRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  gap: 1rem;
`;
const SearchField = styled.input`
  width: 30%;
  min-width: ${({ $searchFieldMinWidth }) => $searchFieldMinWidth || "300px"};
`;
const StyledButton = styled(Button)(
  ({ $isRounded }) => css`
    border-radius: ${$isRounded ? "4px" : "0px"};
  `
);
const SearchForm = ({
  query = "",
  onSearch,
  onReset = () => {
  },
  placeholder = void 0,
  searchFieldMinWidth = "",
  roundedButtons = false
}) => {
  const { t } = useTranslation("enterprise_security_app");
  const [searchTerm, setSearchTerm] = useState(query);
  const handleOnSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (searchTerm) onSearch(searchTerm);
    else onReset();
  };
  const handleReset = () => {
    setSearchTerm("");
    onReset();
  };
  return /* @__PURE__ */ React.createElement(SearchRow, null, /* @__PURE__ */ React.createElement("form", { className: "form-inline", onSubmit: handleOnSearch }, /* @__PURE__ */ React.createElement(FormContent, null, /* @__PURE__ */ React.createElement(
    SearchField,
    {
      id: "search-input",
      type: "text",
      "data-testid": "search-input",
      placeholder: placeholder != null ? placeholder : t("search_form.placeholder"),
      autoComplete: "off",
      value: searchTerm,
      onChange: (e) => setSearchTerm(e.target.value),
      className: "query form-control",
      $searchFieldMinWidth: searchFieldMinWidth
    }
  ), /* @__PURE__ */ React.createElement(
    StyledButton,
    {
      bsStyle: "primary",
      "data-testid": "execute-search",
      onClick: handleOnSearch,
      $isRounded: roundedButtons
    },
    t("search_form.search")
  ), /* @__PURE__ */ React.createElement(StyledButton, { "data-testid": "reset-search", onClick: handleReset, $isRounded: roundedButtons }, t("search_form.reset")))));
};
export default SearchForm;
